module.exports = __webpack_public_path__ + "img/mobile/Menus-paytable/fs_title@2x.png?1.0.17";